import { Grid } from "@mui/material";
import React, { useEffect, useState } from "react";
import WSDataGrid, { IColumns } from "../../../Components/DataGrid/WSDataGrid";
import { useNavigate } from "react-router-dom";
import { updateMainHeader } from "../../../commonFunctions/CommonFunctions";
import { breadCrumbsStore } from "../../../Components/BreadCrumbs/BreadCrumbsListner";
import Inventory2Icon from '@mui/icons-material/Inventory2';
import { labelStore } from "../../../FrontEnd/UpdateChange/LableStore";
import { useDispatch } from "react-redux";
import { useSnackbar } from "../../../Components/Snackbar/SnackBarContext";
import ConfirmationPopup from "../../../Components/Confirmation/Confirmation";
import { resetDataComponent } from "../../../StateManagement/actions";


export const StockReturnList: React.FC = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { showMessage } = useSnackbar();

  const [selectedId, setSelectedId] = useState<string | number>(0);
  const [isPopupOpen, setPopupOpen] = useState(false);

  // Header
   useEffect(() => {
  updateMainHeader("Inventory");
  labelStore.updateIcon(<Inventory2Icon sx={{ fontSize: 32 }} />);
}, []);

  // Breadcrumbs
  breadCrumbsStore.updateBreadCrumbs([
    { "Stock Return": "/stock-return/list" },
  ]);

  const source = {
    url: "stockreturn/list",  
    page: 1,
    pageSize: 10,
    filter: [],
    sort: [],
    type: 'GET' as const 
  };
 
  const columns: IColumns[] = [
    { header: "Date", fieldName: "CreatedDate" ,type:"date"},
    { header: "Item Name", fieldName: "ItemName" },
    { header: "Warehouse", fieldName: "WarehouseName" },
    { header: "Quantity", fieldName: "Quantity" },
    { header: "Return Type", fieldName: "ReturnType" },
    { header: "Remarks", fieldName: "Remarks" },
    { header: "Created By", fieldName: "CreatedByName" },
    {
      header: "Actions",
      fieldName: "actions",
      type: "action",
      actions: ["Edit", "Delete"],
      actionCallback: (action: string, row: any) => {
        console.log("🔍 Row data:", row);


        const StockReturnId = row.StockReturnId;
        if (!StockReturnId) {
          console.error("❌ No valid ID found in row:", row);
          showMessage("Invalid bank data - missing ID", "error");
          return;
        }

        if (action === "Delete") {
            console.log("🗑️ Delete clicked:", StockReturnId);
          setSelectedId(StockReturnId);
          setPopupOpen(true);
        }
          
        else if (action === "Edit") {
          console.log("✏️ Navigating to edit:", StockReturnId);
          navigate(`/stock-return/${StockReturnId}`);
        }
      },
    },

   
  ];

 

  const handleClick = () => {
    navigate("/stock-return");
  };

  return (
    <Grid p={3}>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <WSDataGrid
            id="stockreturnGrid"
            title="Stock Return"
            headerType="modern"
            columns={columns}
            source={source}
            rowsPerPageCount={10}
            searchBox={{ searchMode: "query" }}
            addButton={{ label: "Add New Item", color: "secondary" }}
            onAddButtonClick={handleClick}
            
            gridHeaderSx={{
              backgroundColor: "whitesmoke",
              border: "1px solid whitesmoke",
            }}
          />
        </Grid>
      </Grid>

      <ConfirmationPopup
        type="DELETE"
        apiUrl="stockreturn"
        id={selectedId}
        confirmMessage="Are you sure you want to delete this bank?"
        open={isPopupOpen}
        onClose={() => setPopupOpen(false)}
        onConfirm={(data: any) => {
          dispatch(resetDataComponent("stockreturnGrid"));
          if (data.success === true) {
            showMessage(data?.message, "success");
          } else {
           showMessage(data?.detail, "error");
          }
        }}
      />
    </Grid>
  );
};